/**
 * AIF-01 — AI model type display labels + select options. Single source so
 * the list page, detail page and dialogs render the same wording.
 */
import type { AiFindingModelType } from "@aeriosiq/types";

export const MODEL_TYPE_LABELS: Record<AiFindingModelType, string> = {
  object_detection: "Object detection",
  segmentation: "Segmentation",
  classification: "Classification",
};

export const MODEL_TYPE_OPTIONS: {
  value: AiFindingModelType;
  label: string;
}[] = [
  { value: "object_detection", label: MODEL_TYPE_LABELS.object_detection },
  { value: "segmentation", label: MODEL_TYPE_LABELS.segmentation },
  { value: "classification", label: MODEL_TYPE_LABELS.classification },
];

export function modelTypeLabel(type: AiFindingModelType): string {
  return MODEL_TYPE_LABELS[type];
}
